export const enCorrelation = {
  'correlation.pageTitle': 'Correlation Analysis',
  'correlation.pageSubtitle': 'Analyze and visualize correlations between measurement points',
  'correlation.placeholderTitle': 'No parameters selected.',
  'correlation.placeholderDescription': 'Choose correlation result to visualize data.',
  'correlation.sectionTitle': 'Choose Parameters',
  'correlation.submittedCalculations': 'Submitted calculations',
  'correlation.correlationsResults': 'Correlation Results',
  'correlation.chooseValue': 'Choose value',
  'correlation.startNewCalculation': 'Start new calculation',
  'correlation.tso': 'TSO',
  'correlation.tso.required': 'Please select at least 1 TSO',
  'correlation.start': 'Start',
  'correlation.start.required': 'Please select a start date',
  'correlation.end': 'End',
  'correlation.end.required': 'Please select an end date',
  'correlation.singleParameter': 'Single Parameter',
  'correlation.multipleParameters': 'Multiple Parameters',
  'correlation.measurementParameter': 'Measurement Parameter',
  'correlation.measurementParameter.required': 'Please choose a value',
  'correlation.significanceThreshold': 'Significance Threshold |r| >',
  'correlation.significanceThreshold.required': 'Please enter a decimal value between 0 and 1',
  'correlation.enterValue': 'Enter value',
  'correlation.invalidValue': 'Please enter a valid number',
  'correlation.resetAll': 'Reset all',
  'correlation.submitCalculation': 'Submit calculation',
  'correlation.dialogTitle': 'Submit calculation',
  'correlation.dialogContent':
    'This correlation calculation with the selected parameters can be submitted and saved. The calculations can then be found under “Correlation Results”. Once the calculations have been completed, they can then be selected.',
  'correlation.dialogTextfieldTitle': 'Name for correlation calculation',
  'correlation.dialogTextfieldPlaceholder': 'Enter a name',
  'correlation.dialogTextfieldHint': 'Hint: Allowed characters are a-zA-Z0-9äöüÄÖÜß\s\-_()/.',
  'correlation.dialogTextfieldValidationError': 'Invalid characters detected. Please remove unsupported symbols.',
  'correlation.dialogTextfieldValidationInvalidName': 'Please enter a valid name.',
  'correlation.cancel': 'Cancel',
  'correlation.snackbarSubmitSuccess': 'Calculation was successfully submitted and is now being processed.',
  'correlation.snackbarSubmitError1': 'Calculation could not be submitted. Please try again.',
  'correlation.deleteDialogTitle': 'Delete correlation result',
  'correlation.deleteDialogContentPart1': 'Are you sure you want to delete “',
  'correlation.deleteDialogContentPart2': '”? This action cannot be undone.',
  'correlation.delete': 'Delete',
  'correlation.snackbarDeleteSuccess': 'Calculation was successfully deleted.',
  'correlation.snackbarDeleteError': 'Calculation could not be deleted. Please try again.',
  'correlation.legend.single': 'Correlation coefficient',
  'correlation.legend.multiple': 'Correlating measurement parameters',
  'correlation.value': 'Value',
  'correlation.tooltip1': 'out of',
  'correlation.tooltip2': 'parameters exceed the threshold',
  'correlation.tooltip.none': 'None',
  'correlation.couldNotCalculate': 'Couldn`t be calculated',
  'correlation.matrix': 'Correlation Matrix',
  'correlation.matrix.description':
    'Measurement devices without available data are automatically hidden and excluded from the correlation calculation.',
};
